import { useEffect, useLayoutEffect, useState } from 'react';
import TablePaginationMui from '@mui/material/TablePagination';
import { useTranslation } from 'react-i18next';

export type Pagination = {
  pageNumber: number;
  pageSize: number;
  totalCount: number | undefined;
};

export const TablePagination = ({
  pagination,
  onChange,
}: {
  pagination: Pagination;
  onChange: (pagination: Pagination) => void;
}) => {
  const [page, setPage] = useState(pagination.pageNumber);
  const [rowsPerPage, setRowsPerPage] = useState(pagination.pageSize);

  const { t } = useTranslation();

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    onChange({ ...pagination, pageNumber: newPage + 1 });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onChange({
      ...pagination,
      pageNumber: 1,
      pageSize: parseInt(event.target.value, 10),
    });
  };

  useEffect(() => {
    setPage(pagination.pageNumber);
    setRowsPerPage(pagination.pageSize);
  }, [pagination]);

  useLayoutEffect(() => {
    const paginationRoot = document.querySelector('.MuiTablePagination-root');

    const paginationSelectLabel = document.querySelector(
      '.MuiTablePagination-selectLabel'
    );

    const paginationDisplayedRows = document.querySelector(
      '.MuiTablePagination-displayedRows'
    );

    if (paginationRoot && paginationRoot instanceof HTMLElement) {
      const gutters = paginationRoot.children[0] as HTMLElement;

      gutters.style.paddingRight = '0';
      gutters.style.paddingLeft = '24px';
    }

    if (paginationSelectLabel && paginationSelectLabel instanceof HTMLElement) {
      paginationSelectLabel.style.marginBottom = '0';

      paginationSelectLabel.innerHTML = t(`general.${'Rows per page'}`);
    }

    if (
      paginationDisplayedRows &&
      paginationDisplayedRows instanceof HTMLElement
    ) {
      paginationDisplayedRows.style.marginBottom = '0';

      paginationDisplayedRows.innerHTML = paginationDisplayedRows.innerHTML
        .replace('of', t(`general.${'of'}`, 'of'))
        .replace('من', t(`general.${'of'}`, 'of'));
    }
  });

  useLayoutEffect(() => {
    const style = document.createElement('style');

    style.innerHTML = `
        .MuiPaper-root ul li {
            font-family: "Tajawal" !important;
        }
    `;

    const head = document.head;

    head.appendChild(style);
  }, []);

  return (
    <TablePaginationMui
      component="div"
      count={pagination.totalCount || 10}
      page={page - 1}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      sx={{
        '& div, & p': {
          fontFamily: 'Tajawal !important',
        },
      }}
    />
  );
};
